export const TRANSLATION_KEY = 'questionnaire';
export const PATHS = {
  NO_PERMISSIONS_PAGE: '/no-permissions-page',
};
